import { FamilyAnswersResponseDto } from '@families-link/shared';
import { useReactTable, getCoreRowModel } from '@tanstack/react-table';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CoreTable, CoreTableEmptyBody } from '../../../_core/components/_ui/core-table';
import { TableListQueryResponse } from '../../../_core/interfaces/table-list-query.interface';
import { useFamilyQuestionAnswersTableColumns } from '../../hooks/table-columns/family-question-answers-columns.hook';

type FamilyQuestionAnswersTableProps = TableListQueryResponse<FamilyAnswersResponseDto>;

export const FamilyQuestionAnswersTable: FC<FamilyQuestionAnswersTableProps> = (props) => {
	const { data, sorting, onSortingChange, loading, hasMore, fetchMore, scrollRef } = props;

	const [t] = useTranslation();

	const columns = useFamilyQuestionAnswersTableColumns();

	const table = useReactTable<FamilyAnswersResponseDto>({
		data,
		columns,
		state: {
			sorting,
		},
		onSortingChange,
		getCoreRowModel: getCoreRowModel(),
	});

	return (
		<CoreTable
			px={0}
			ref={scrollRef}
			loading={loading}
			hasMore={hasMore}
			threshold={200}
			emptyListComponent={
				<CoreTableEmptyBody label={t('profile.sessions.table.empty-title')} description={t('surveys.no-answers')} />
			}
			fetchMore={fetchMore}
			rowModel={table.getRowModel()}
			headerGroups={table.getHeaderGroups()}
		/>
	);
};
